import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import AcUnitIcon from '@mui/icons-material/AcUnit';
// Google auth UI removed

const Header = () => (
  <AppBar
    position="static"
    sx={{ background: 'linear-gradient(90deg, #b71c1c 0%, #000000 100%)' }}
  >
    <Toolbar>
      <AcUnitIcon sx={{ mr: 1 }} />
      <Typography variant="h6" sx={{ flexGrow: 1 }}>
        Cool Roof Savings Calculator
      </Typography>
    </Toolbar>
  </AppBar>
);

export default Header;
